/**
 * Pure helpers for SuggestionRow.
 */

/** Build the reason line from the two graph signals (mutual friends preferred). */
export function buildSuggestionReason(
  mutualFriendCount: number,
  sharedSquadOrgCount: number
): string {
  if (mutualFriendCount > 0) {
    return `${mutualFriendCount} mutual friend${mutualFriendCount === 1 ? '' : 's'}`
  }
  if (sharedSquadOrgCount > 0) {
    return sharedSquadOrgCount === 1 ? 'Same squad' : `In ${sharedSquadOrgCount} shared groups`
  }
  return 'Suggested for you'
}
